import type { BestCalculationResult } from 'grts-utils/types/ProfitCalcs';

/** Compound daily rate as a percentage, from the stored log rate:
 *  dailyRate = e^growthRate − 1. This is the readable form of the scalar the
 *  CPC search actually ranks on. */
export const toDailyRatePercent = (growthRate: number): number =>
  (Math.exp(growthRate) - 1) * 100;

export const formatDailyRate = (growthRate: number, digits = 4): string =>
  `${toDailyRatePercent(growthRate).toFixed(digits)} %`;

/** Result files written before the rate switch store baseScore only. Those fall
 *  back to baseScore, which is NOT comparable to a rate — always label it. */
export const hasDailyRate = (
  result: BestCalculationResult | null | undefined,
): boolean => typeof result?.growthRate === 'number';
